// extracted by mini-css-extract-plugin
export var table = "_yc-0";